<template>
    <v-dialog 
        v-model="dialog"
        :width="step < 2 ? '536px' : '1088px'"
        persistent
    >
        <v-card
            width="536px"
            class="close-offer py-10 mx-auto"
            v-if="step === 0"
        >
            <v-card-title
                class="stepOne px-10"
            >
                ¿Contrataste a alguien para el cargo de <br> {{ offer.title }}?
            </v-card-title>
            <v-card-text class="px-10 pb-2">
                <p class="close-offer__text">
                  Cuando presionas <b>Cerrar Proceso</b>, significa que finalizaste tu búsqueda,
                  con esta acción quienes postularon sabrán que el proceso ha concluído. No te preocupes, 
                  mantendrás el acceso a tu proceso y a los candidatos que participaron.
                </p>
            </v-card-text>
            <v-card-text
                class="close-offer__text"
            >
                <v-list
                    class="close-offer__list mx-auto"
                >
                    <v-list-item-group
                        v-model="response"
                        active-class="close-offer__item--active"
                        mandatory
                    >
                        <v-list-item
                            class="close-offer__item"
                        >
                            {{ responseOptions[0]}}
                            
                        </v-list-item>
                        <v-expand-transition>
                            <v-list-item-group
                                v-show="response === 0"
                                class="close-offer__item my-auto"
                            >
                                <v-list-item>
                                    <v-select
                                        v-model="userSelected"
                                        :items="itemsSelected"
                                        item-value="user"
                                        label="Selecciona a tu candidato/a"
                                        solo
                                        hide-details
                                        class="my-2"
                                    >
                                        <template v-slot:selection="{ item }">
                                            {{ getFullname(item.user) }}
                                        </template>
                                        <template v-slot:item="{ item }">
                                            {{ getFullname(item.user) }}
                                        </template>
                                    </v-select>
                                </v-list-item>
                            </v-list-item-group>
                        </v-expand-transition>
                        <v-list-item
                            class="close-offer__item"
                        >
                            {{ responseOptions[1]}}
                        </v-list-item>
                        <v-list-item
                            class="close-offer__item"
                        >
                            {{ responseOptions[2]}}
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-card-text>
            <v-card-actions
                class="d-flex justify-end px-10"
            >
                <v-btn
                    class="close-offer__btns"
                    color="#3BADFF"
                    @click="decline"
                    outlined
                >
                    Cancelar
                </v-btn>
                <v-btn
                    class="close-offer__btns"
                    color="#3BADFF"
                    @click="nextWindows"
                    :disabled="response === 0 && !(userSelected !== null)"
                    outlined
                    :loading="isLoading"
                >
                    Siguiente
                </v-btn>
            </v-card-actions>       
        </v-card>
        <v-card
            width="536px"
            class="close-offer py-10 mx-auto"
            v-else-if="step === 1"
        >
            <v-card-title
                class="stepTwo px-10"
            >
                Avísale a todos los que se interesaron en tu oferta el cierre del proceso.
            </v-card-title>
            <v-card-text
                class="close-offer__text px-10"
            >
                Los candidatos valoran a las organizaciones que les avisan el cierre y agradecen por haber postulado.
            </v-card-text>
            <v-card-text
                class="text-start px-10"
            >
                <span class="close-offer__sub-text">
                    Selecciona a quienes quieres enviarles este mensaje:
                </span>
                <v-col class="px-0">
                    <v-checkbox
                        v-model="sendMsgTo.postulated"
                        :label="`Postulantes (${countPostulated})`"
                        color="#3BADFF"
                        hide-details
                        dense
                    ></v-checkbox>
                    <v-checkbox
                        v-model="sendMsgTo.discarded"
                        :label="`Descartadas (${countDiscarded})`"
                        color="#3BADFF"
                        hide-details
                        dense
                    ></v-checkbox>
                    <v-checkbox
                        v-model="sendMsgTo.interviewed"
                        :label="`Entrevistas (${countInterviewed})`"
                        color="#3BADFF"
                        hide-details
                        dense
                    ></v-checkbox>
                </v-col>
                <v-col class="close-offer__disclaimer px-0">
                    Los postulantes que ya hayan sido notificados como descartados no volverán a recibir este mensaje.
                </v-col>
                <hr v-if="anyOne"/>
            </v-card-text>
            
            <v-card-text
                class="px-10 mt-10"
                v-if="anyOne"
            >
                <span class="close-offer__sub-text">
                    Mensaje
                </span>
                <v-textarea
                    outlined
                    auto-grow
                    v-model="message"
                    hide-details
                ></v-textarea>
            </v-card-text>
            
            <v-card-actions
                class="px-10"
            >
                <v-row justify="space-between">
                    <v-col cols="6" class="d-flex justify-start px-0">
                        <v-btn
                            class="close-offer__btns"
                            color="#3BADFF"
                            text
                            @click="previusWindows"
                        >
                            <v-icon small>
                                mdi-arrow-left
                            </v-icon>
                            Volver
                        </v-btn>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-end px-0">
                        <v-btn
                            class="close-offer__btns mx-2"
                            color="#3BADFF"
                            @click="decline"
                            outlined
                        >
                            Cancelar
                        </v-btn>
                        <v-btn
                            class="close-offer__btns elevation-0"
                            color="#3BADFF"
                            @click="sendMsg"
                            dark
                            :loading="isLoading"
                            v-if="anyOne"
                        >
                            Enviar mensaje
                        </v-btn>
                        <v-btn
                            class="close-offer__btns elevation-0"
                            color="#3BADFF"
                            @click="nextWindows"
                            dark
                            :loading="isLoading"
                            v-else
                        >
                            Cerrar el proceso sin enviar mensaje
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
        <v-card
            class="close-offer__nps py-4"
            width="1088px"
            v-else-if="step === 2"
        >
            <v-card
                width="352px"
                class="elevation-10 mx-auto py-4"
            >
                <v-card-title
                    class="stepThree pa-0"
                >
                    <v-col class="text-center">
                        El proceso fue cerrado <br> exitosamente
                    </v-col>
                </v-card-title>
                <v-card-text>
                    <v-row justify="center">
                        <v-icon size="65" class="close-offer__icon close-offer__icon--success ma-1">
                            mdi-check-circle
                        </v-icon>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-card-text class="close-offer__nps close-offer__nps--presentations mt-10 mx-auto pa-3">
                Ahora, ¿nos ayudas a mejorar nuestro servicio respondiendo la siguiente pregunta?
            </v-card-text>
            <v-card-text class="close-offer__nps close-offer__nps--question mx-auto text-center py-5">
                ¿Qué probabilidad hay de que recomiendes Trabajo con Sentido a amigos/as o compañeros/as de trabajo?
            </v-card-text>
            <v-card-actions
                class="close-offer__nps close-offer__nps--response mx-auto"
            >
                <v-col
                    class="text-center pa-0"   
                >
                    <div class="top-response d-flex">
                        <div class="face-icon" v-for="face in 11" :key="face">
                            <v-btn 
                                @click="nps.score = (face - 1)"
                                icon
                            >
                                    <!-- width="38px" -->
                                <v-img
                                    :src="getEmoticon[face - 1]"
                                    :class="face > 9 ? 'orange-face': face > 7  && face < 10 ? 'bluelight-face' : 'blue-face'"
                                >
                                </v-img>
                            </v-btn>
                        </div>
                    </div>
                    <div class="bottom-response d-flex">
                        <div 
                            :class="num > 9 ? 'orange-nps': num > 7  && num < 10 ? 'bluelight-nps' : 'blue-nps'" 
                            v-for="num in 11"
                            :key="num"
                            @click="nps.score = (num - 1)"
                        >
                            {{num - 1}}
                        </div>
                    </div>
                    <div class="text-response d-flex justify-space-between py-3">
                        <div>
                            Absolutamente improbable
                        </div>
                        <div>
                            Muy probable
                        </div>
                    </div>
                </v-col>
            </v-card-actions>
            <v-card-text class="close-offer__nps close-offer__nps--response text-center mx-auto">
                <v-chip
                    class="chip-response rounded-xl"
                    :color="getColor[nps.score]"
                >
                    <span class="text-chip mx-8">
                        {{nps.score}}
                    </span>
                </v-chip>
            </v-card-text>
            <v-card-text
                class="close-offer__nps close-offer__nps--response mx-auto"
            >
                <v-textarea
                    solo
                    auto-grow
                    v-model="nps.userAdvice"
                    placeholder="¿Qué podemos mejorar?"
                    hide-details
                    class="mx-auto"
                ></v-textarea>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    color="#3BADFF"
                    class="mx-auto close-offer__nps send"
                    dark
                    outlined
                    @click="sendNps"
                    :loading="isLoading"
                >
                    ENVIAR
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from "vuex";


export default {
    name: "CloseOffer",
    props: {
        offer: Object,
        dialog: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isLoading: false,
            nps: {
                score: 10,
                userAdvice: "",
            },
            step: 0,
            response: 0,
            responseOptions: [
                "Si, encontré al candidato a tráves de Trabajo con Sentido!",
                "Candidata/o Contratado en otro lugar",
                "El proceso se cerró sin contratación"
            ],
            userSelected: null,
            sendMsgTo: {
                interviewed: true,
                discarded: true,
                postulated: true
            },
            message: "",
            email: {
                to: "",
                service: {
                    subject: "",
                },
                context: {
                    message: ""
                }
            }
        };
    },
    computed: {
        anyOne() {
            return this.sendMsgTo.interviewed || this.sendMsgTo.discarded || this.sendMsgTo.postulated;
        },
        countPostulated() {
            return (this.postulations.postulated.length).toString().padStart(3, "0");
        },
        countSelected() {
            return (this.postulations.selected.length).toString().padStart(3, "0");
        },
        countInterviewed() {
            return (this.postulations.interviewed.length).toString().padStart(3, "0");
        },
        countDiscarded() {
            return (this.postulations.discarded.length).toString().padStart(3, "0");
        },
        getAddrs() {
            let list = [];
            if (this.sendMsgTo.interviewed) {
                const interviewed = this.postulations.interviewed.map(item => ({ addr: item.user.email, name: `${item.user.firstName} ${item.user.lastName}` }));
                list = list.concat(interviewed);
            }
            if (this.sendMsgTo.postulated) {
                const postulated = this.postulations.postulated.map(item => ({ addr: item.user.email, name: `${item.user.firstName} ${item.user.lastName}` }));
                list = list.concat(postulated);
            }
            if (this.sendMsgTo.discarded) {
                const filters = this.postulations.discarded.filter(item => item.notified && !item.notified.discarded);
                const discarded = filters.map(item => ({ addr: item.user.email, name: `${item.user.firstName} ${item.user.lastName}` }));
                list = list.concat(discarded);
            }
            return list;
        },
        getNames() {
            let list = [];
            if (this.sendMsgTo.interviewed) {
                const interviewed = this.postulations.interviewed.map(item => `${item.user.firstName} ${item.user.firstName}`);
                list = list.concat(interviewed);
            }
            if (this.sendMsgTo.postulated) {
                const postulated = this.postulations.postulated.map(item => `${item.user.firstName} ${item.user.firstName}`);
                list = list.concat(postulated);
            }
            if (this.sendMsgTo.discarded) {
                const discarded = this.postulations.discarded.map(item => `${item.user.firstName} ${item.user.firstName}`);
                list = list.concat(discarded);
            }
            return list;
        },
        getIds() {
            let list = [];
            if (this.sendMsgTo.interviewed) {
                const interviewed = this.postulations.interviewed.map(item => item.id);
                list = list.concat(interviewed);
            }
            if (this.sendMsgTo.postulated) {
                const postulated = this.postulations.postulated.map(item => item.id);
                list = list.concat(postulated);
            }
            if (this.sendMsgTo.discarded) {
                const discarded = this.postulations.discarded.map(item => item.id);
                list = list.concat(discarded);
            }
            return list;
        },
        getEmoticon() {
            return [
                require("@/assets/images/emoticons/face-emoticon0.svg"),
                require("@/assets/images/emoticons/face-emoticon1.svg"),
                require("@/assets/images/emoticons/face-emoticon2.svg"),
                require("@/assets/images/emoticons/face-emoticon3.svg"),
                require("@/assets/images/emoticons/face-emoticon4.svg"),
                require("@/assets/images/emoticons/face-emoticon5.svg"),
                require("@/assets/images/emoticons/face-emoticon6.svg"),
                require("@/assets/images/emoticons/face-emoticon7.svg"),
                require("@/assets/images/emoticons/face-emoticon8.svg"),
                require("@/assets/images/emoticons/face-emoticon9.svg"),
                require("@/assets/images/emoticons/face-emoticon10.svg")
            ];
        },
        getColor() {
            return [
                "#001B7C",
                "#0931C1",
                "#1243EB",
                "#305AEB",
                "#167FFA",
                "#2586F8",
                "#169AFA",
                "#3BADFF",
                "#3BADFF",
                "#FFA42E",
                "#FF8E03"
            ];
        },
        itemsSelected() {
            return this.postulations?.selected ?? [];
        },
        postulations() {
            const selected = this.offer?.postulations?.filter(item => item.status.private === "selected") ?? [];
            const interviewed = this.offer?.postulations?.filter(item => item.status.private === "interviewing") ?? [];
            const discarded = this.offer?.postulations?.filter(item => item.status.private === "discarded" && !item?.notified?.discarded) ?? [];
            const postulated = this.offer?.postulations?.filter(item => item.status.private === "sent") ?? [];

            return {
                selected,
                interviewed,
                discarded,
                postulated,
            };
        }
    },
    methods: {
        ...mapActions("notifications", ["sendEmail"]),
        ...mapActions("offers", ["recordClose", "recordNps", "updateNotified"]),
        sendNps() {
            // TODO: Guardar NPS Aqui.
            this.isLoading = true;
            this.recordNps({
                ...this.nps,
                offerId: this.offer.id
            }).then(response => {
                this.$emit("closeOfferNow", this.offer.id);
                this.decline();
                this.isLoading = false;
            }).catch(error => {
                console.error(error);
            });
        },
        async sendMsg() {
            this.isLoading = true;
            this.email.to = this.getAddrs;
            // this.email.context.names = this.getNames; 
            this.email.service.subject = `Cierre de proceso al cargo "${this.offer.title}"`;
            this.email.context.message = this.message;
            this.email.to.forEach(async(email)=> {
                try {
                    await this.sendEmail({
                        to: email.addr,
                        service: {
                            template: "general-multiple",
                            subject: this.email.service.subject
                        },
                        context: {
                            name: email.name,
                            message: this.email.context.message
                        }
                    });
                } catch (error) {
                    console.log(error);
                }
            });    
            this.recordClose({
                offerId: this.offer.id,
                response: this.responseOptions[this.response],
                selectedUsers: [this.userSelected]
            }).then(async(result) => {
                // const r = await this.updateNotified({
                //     offerId: this.offer.id,
                //     postulationsId: this.getIds
                // });
                this.step = this.step + 1;
                this.isLoading = false;
            }).catch(error => {
                console.error(error);
                this.isLoading = false;
            });
        },
        getFullname(user) {
            return `${user.firstName} ${user.lastName}`;
        },
        nextWindows() {
            if (this.step === 0) {
                this.saveResponse = {
                    response: this.responseOptions[this.response],
                    userId: this.response < 1 && this.userSelected.id || null
                };
                this.step = this.step + 1;
                this.message = `Hola ¿cómo estás?, Espero que muy bien.\n\n Primero que todo, queremos agradecer tu interés en la postulación al cargo de ${this.offer.title} y comentarte que dicha búsqueda ha finalizado y en esta oportunidad no has sido seleccionado/a.\n\n Te invitamos a continuar revisando nuestras futuras ofertas y te deseamos todo el éxito en tu búsqueda.\n\n¡Saludos!\n\n${this.offer.organization.name}\n\n`;
            } else if (this.step === 1) {
                this.step = this.step + 1;
            }
        },
        previusWindows() {
            if (this.step === 1) {
                this.message = "";
            } 
            this.step = this.step - 1;
        },
        decline() {
            this.$emit("decline");
            this.questions = 0;
            this.response = 0;
            this.userSelected = null;
            this.sendMsgTo = {
                interviewed: true,
                discarded: true,
                postulated: true
            };
            this.step = 0;
        }
    }
};
</script>

